import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=80350aae&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/fontFace.css?vue&type=style&index=0&lang=css&"
import style1 from "../../assets/css/fontFace.css?vue&type=style&index=1&lang=css&"
import style2 from "./sidebar.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports